//tdm = tag der musikschulen
import api from './services/mkm.api.js'

const resource = '/TDMAnmeldung'

export default {
    senden(payload) {
        return api.post(`${resource}`, payload)
    },
}